import { Card } from "antd";
import React from "react";
import Utils from "../../utils/Utils";

const AudioAnomaly = ({ interviewAnalysisIntegrityData, updateVideoTrack }) => {
  return (
    <>
      <Card className="bg-[#D4E7FD] mt-4 border-2 border-[#A9CFFB]  w-full ">
        <div className="text-[#475467] text-lg font-semibold pb-2 flex items-center gap-3">
          Audio Anomaly Analysis
          {"  "}
        </div>
        <div className="flex flex-wrap items-center gap-5 max-h-52 overflow-y-auto scroll">
          {interviewAnalysisIntegrityData?.audioAnomalyData?.length > 0 ? (
            interviewAnalysisIntegrityData?.audioAnomalyData.map(
              (item, index) => (
                <Card key={index} className="sm:w-80 w-full text-center">
                  <p className="font-semibold">
                    <span className="text-orange-400 text-lg">
                      {item.audioAnomalyType} {/* Device change detected */}
                    </span>
                  </p>
                  <p className="text-blue-500">
                    <span
                      onClick={() => {
                        updateVideoTrack(item.timestamp);
                        window.scrollTo({
                          top: 200,
                          behavior: "smooth",
                        });
                      }}
                      className="cursor-pointer text-blue-500 font-medium border-b-2 border-blue-400"
                    >
                      {Utils.convertSecondsToTime(item.timestamp)}
                    </span>
                  </p>
                </Card>
              ),
            )
          ) : (
            <div className="mt-[.15rem] text-slate-600 text-[.98rem]">
              No audio anomalies found.
            </div>
          )}
        </div>
      </Card>
      <div className="text-red-500 mt-1 text-sm">
        <strong>Note: </strong>
        This analyzes irregularities in the candidate’s audio during the
        interview, such as background voices, unusual noise levels, or multiple
        speakers. Such anomalies may impact the integrity.
      </div>
    </>
  );
};

export default AudioAnomaly;
